import { AuthPage } from '@components/pages/auth';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export default function ForgotPasswordPage() {
  return <AuthPage type="forgotPassword" />;
}

export const getStaticProps: GetStaticProps = async (context) => {
  const i18nProps = await serverSideTranslations(context.locale ?? 'en', [
    'common',
  ]);

  return {
    props: {
      ...i18nProps,
    },
  };
};
